import { POSSIBLE_ENGINES } from '@/utils/search-engines'
import { orderByOrdering } from '@/utils/ordering'
import { MAX_CHARS_STRATEGY_TITLE_HALF } from '@/utils/constants'

const isEmpty = (obj) => {
  return Object.keys(obj).length === 0
}

const hasKey = (obj, key) => {
  return key in obj
}

const keyUndefinedOrNull = (obj, key) => {
  return isEmpty(obj) || !(hasKey(obj, key)) || obj.name === null
}

const getDefaultSearchFromName = (state, name) => {
  let r = null
  if (name) {
    const m = POSSIBLE_ENGINES.find(e => {
      return e.name === name
    })
    if (typeof m !== 'undefined') {
      r = m
    }
  }
  if (r === null) {
    r = state.defaultEngine
  }
  return r
}

const displayQueryNameTrimmed = (state) => {
  if (state.query) {
    let n = state.query.name
    let r = n
    if (n && n.length > MAX_CHARS_STRATEGY_TITLE_HALF * 2) {
      r = n.slice(0, MAX_CHARS_STRATEGY_TITLE_HALF)
      r += '...'
      r += n.slice(MAX_CHARS_STRATEGY_TITLE_HALF * -1)
    }
    return r
  } else {
    return ''
  }
}

const trimQueryName = (queryName) => {
  let n = queryName
  let r = n
  if (n && n.length > MAX_CHARS_STRATEGY_TITLE_HALF * 2) {
    r = n.slice(0, MAX_CHARS_STRATEGY_TITLE_HALF)
    r += '...'
    r += n.slice(MAX_CHARS_STRATEGY_TITLE_HALF * -1)
  }
  return r
}

const tidyUpQueryData = (queryBodyString) => {
  const r = JSON.parse(queryBodyString)
  if (r.nodeDataArray) {
    const groups = []
    r.nodeDataArray.forEach(node => {
      if (node.isGroup) {
        if (!groups.includes(node.key)) {
          groups[node.key] = []
        }
      }
    })
    r.nodeDataArray.forEach(node => {
      if (node.group) {
        groups[node.group].push(node)
      }
    })
    let hasDuplicateOrdering = false
    // Make sure ordering of items in each group is distinct
    for (let key in groups) {
      const group = groups[key]
      const orderings = []
      let hasNullOrdering = false
      group.forEach(node => {
        if (node.ordering !== null) {
          if (orderings.includes(node.ordering)) {
            hasDuplicateOrdering = true
          } else {
            orderings.push(node.ordering)
          }
        } else {
          hasNullOrdering = true
        }
      })
      if (hasDuplicateOrdering || hasNullOrdering) {
        group.sort(orderByOrdering)
        let ordering = 10
        group.forEach(node => {
          node.ordering = ordering
          ordering += 10
        })
      }
    }
  }
  return JSON.stringify(r)
}

const removeUrlPrefix = (url) => {
  let temp = url.split('https://')[1]
  if (temp.includes('www.')) {
    return temp.split('www.')[1]
  }
  return temp
}

const orderObjectKeys = (unordered) => {
  return Object.keys(unordered).sort().reduce(
    (obj, key) => {
      obj[key] = unordered[key]
      return obj
    },
    {}
  )
}

export {
  isEmpty,
  hasKey,
  keyUndefinedOrNull,
  getDefaultSearchFromName,
  displayQueryNameTrimmed,
  trimQueryName,
  tidyUpQueryData,
  removeUrlPrefix,
  orderObjectKeys
}



//////////////////
// WEBPACK FOOTER
// ./store/helper.js
// module id = null
// module chunks = 